import React, { useCallback, useEffect, useState } from "react";
import useDocMembershipQuitApi from "@apis/useDocMembershipQuitApi";
import { useParams } from "react-router-dom";
import MembershipQuitContract104 from "@icoach/documents/membership/quit/version104/MembershipQuitContract104";
import MembershipQuitContract from "@icoach/documents/membership/quit/versionBefore104/MembershipQuitContract";
import useInactivityTimerToggle from "@util/hook/useInactivityTimerToggle";

const MembershipQuitRenderer = ({ isReadOnly }) => {
	const { referenceID, contractID, peopleType } = useParams();
	const [contractData, setContractData] = useState();
	const { getDocMembershipQuitApi } = useDocMembershipQuitApi();

	const doGetDocMembershipQuitApi = async (contractID, referenceID) => {
		const resp = await getDocMembershipQuitApi(contractID, { id: referenceID });
		if (resp) {
			setContractData(resp);
		}
	};

	useInactivityTimerToggle();

	useEffect(() => {
			doGetDocMembershipQuitApi(contractID, referenceID);
		},
		// eslint-disable-next-line
		[]);

	const renderForm = useCallback((contractData) => {
			const { contractVersion } = contractData || {};
			switch (contractVersion) {
				case 104:
					return <MembershipQuitContract104 sourceData={contractData} referenceID={referenceID}
													  contractID={contractID} peopleType={peopleType}
													  isReadOnly={isReadOnly} />;
				case 101:
				case 102:
				case 103:
					return <MembershipQuitContract sourceData={contractData} referenceID={referenceID}
												   contractID={contractID} peopleType={peopleType}
												   isReadOnly={isReadOnly} />;
				default:
					return null;
			}
		},
		// eslint-disable-next-line
		[isReadOnly]);


	return renderForm(contractData);
};

export default MembershipQuitRenderer;
